export default "/images/banner-particulier.jpg";